<div
  [ngClass]="{
    '!bg-white dark:!bg-black-dark-lighter unread':
      isEffectivelyUnread(notification)
  }"
  class="relative rounded-lg pl-3 pr-2 py-2 border border-borders-dark dark:border-black-dark-light bg-whiteshade dark:bg-black-dark-light mb-2"
>
  @if (shouldShowRatingPrompt()) {
  <app-work-quick-rating
    [userId]="user._id"
    [work]="notification.work!"
    [language]="user.language"
    [ratingPromptContext]="getRatingPromptContext()"
    (requestClose)="ratingPromptDismissed = true"
  ></app-work-quick-rating>
  } @else {
  <div
    class="flex justify-start notificationLink"
    [routerLink]="shouldOpenWorkModal() ? null : getRoute(notification.type)"
    (click)="handleNotificationClick()"
    (keyup)="onNotificationKeyUp($event)"
    tabindex="0"
  >
    @if (notification.sender) {
    <app-user-avatar
      class="mr-2"
      [name]="notification.sender.username"
      [picture]="notification.sender.picture"
      [size]="48"
    ></app-user-avatar>
    }
    <div class="flex-1 min-w-0 font-normal text-grey dark:text-lightGrey">
      <span class="font-bold text-black dark:text-white">{{
        notification.sender?.username
      }}</span>
      @if (notification.type === notificationsTypes.ReleaseDigest) {
      <span class="whitespace-pre-line">
        @if (notification.messageParts?.length) { @for (part of
        notification.messageParts; track $index) {
        <span
          [ngClass]="{'font-bold text-black dark:text-white': part.isWorkTitle}"
          >{{ part.text }}</span
        >
        } } @else {
        {{ notification.message }}
        }
      </span>
      } @else {
      {{ message | translate }}
      } @if ( notification.type === notificationsTypes.ListInvitation ||
      notification.type === notificationsTypes.ListRemoval || notification.type
      === notificationsTypes.ListLeft ) {
      <span class="font-bold text-black dark:text-white">{{
        notification.list?.name
      }}</span>
      } @if ( notification.type ===
      notificationsTypes.WorkAddedToCollaborativeCollection || notification.type
      === notificationsTypes.Recommendation || notification.type ===
      notificationsTypes.RecommendationAdded || notification.type ===
      notificationsTypes.RecommendationMessage || notification.type ===
      notificationsTypes.WorkCompanionTag || notification.type ===
      notificationsTypes.WorkTagAccepted || notification.type ===
      notificationsTypes.WorkTagDeclined || notification.type ===
      notificationsTypes.WorkRatingPrompt || notification.type ===
      notificationsTypes.SteamGameAdded ) { @if (notification.list) {
      <span class="font-bold text-black dark:text-white">{{
        notification.list.name
      }}</span>
      } @if ( notification.type ===
      notificationsTypes.WorkAddedToCollaborativeCollection || notification.type
      === notificationsTypes.Recommendation || notification.type ===
      notificationsTypes.WorkCompanionTag || notification.type ===
      notificationsTypes.WorkTagAccepted || notification.type ===
      notificationsTypes.WorkTagDeclined || notification.type ===
      notificationsTypes.WorkRatingPrompt ) { @if (!(notification.type ===
      notificationsTypes.Recommendation && (notification.workCount ?? 1) > 1)) {
      {{ user.language === "en" ? ":" : " :" }}
      } } @if (notification.work) {
      <span class="font-bold italic text-black dark:text-white">{{
        getNotificationWorkTitle(notification.work)
      }}</span>
      @if ( notification.type === notificationsTypes.Recommendation &&
      (notification.workCount ?? 1) > 1 ) {
      {{
        ((notification.workCount ?? 1) === 2
          ? "WORK_RECOMMENDATION_ONE_OTHER"
          : "WORK_RECOMMENDATION_OTHERS"
        ) | translate: {count: (notification.workCount ?? 1) - 1}
      }}
      } @if (notification.type === notificationsTypes.RecommendationAdded) { @if
      (notification.rating !== undefined && notification.rating !== null) {
      {{
        "WORK_RECOMMENDATION_ADDED_RATING"
          | translate: {rating: notification.rating}
      }}
      }
      {{ user.language === "en" ? "!" : " !" }}
      } } } @if (notification.work &&
      hasNotificationWorkCover(notification.work)) {
      <div class="my-1">
        <img
          crossorigin="anonymous"
          class="block w-full h-[120px] object-cover rounded-lg"
          [src]="getNotificationWorkCover(notification.work)"
          alt="{{ notification.work.title }}"
          loading="lazy"
        />
      </div>
      } @if (comment) {
      <div class="italic mb-1 text-ellipsis overflow-hidden">{{ comment }}</div>
      }

      <div class="date font-bold text-sm text-primary-text dark:text-primary">
        {{ getRelativeTime(notification.createdAt) }}
      </div>
    </div>
  </div>

  @if ( notification.type === notificationsTypes.FriendRequest &&
  notification.friendRequestId && notification.sender &&
  !friendsService.isAlreadyFriend(notification.sender, user) &&
  !friendRequestAnswered ) {
  <div>
    <div class="flex justify-center mt-2">
      <button
        class="btn btn-grad btn-small w-[120px] mr-2 !text-base"
        (click)="acceptFriendRequest(getFriendRequestId()!)"
      >
        {{ "ACCEPT" | translate }}
      </button>
      <button
        class="btn btn-transparent btn-small w-[120px] !text-base"
        (click)="rejectFriendRequest(getFriendRequestId()!)"
      >
        {{ "REJECT" | translate }}
      </button>
    </div>
  </div>
  } @if ( notification.type === notificationsTypes.ListInvitation &&
  notification.listInvitationId && !hasAlreadyJoinedList() &&
  !listInvitationAnswered ) {
  <div>
    <div class="flex justify-center mt-2">
      <button
        class="btn btn-grad btn-small w-[120px] mr-2 !text-base"
        (click)="acceptListInvitation(notification.listInvitationId._id)"
      >
        {{ "ACCEPT" | translate }}
      </button>
      <button
        class="btn btn-transparent btn-small w-[120px] !text-base"
        (click)="rejectListInvitation(notification.listInvitationId._id)"
      >
        {{ "REJECT" | translate }}
      </button>
    </div>
  </div>
  } @if ( notification.type === notificationsTypes.WorkCompanionTag &&
  !workCompanionAnswered && requiresAction(notification) ) {
  <div class="mt-3">
    <div class="flex gap-2 mb-2">
      <button
        class="btn btn-grad btn-small flex-1 !text-base"
        (click)="handleWorkCompanionAction('accept_with_sync')"
      >
        {{ "ACCEPT" | translate }}
      </button>
      <button
        class="btn btn-transparent btn-small flex-1 !text-base"
        (click)="handleWorkCompanionAction('decline')"
      >
        {{ "REJECT" | translate }}
      </button>
    </div>
  </div>
  } }
</div>
